import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./smartFilterSpinner.module.scss";

/**
 * iOS-style activity spinner — 8 bars with sequential opacity animation.
 * Used when re-fetching inventory count after filter removal.
 */
const SmartFilterSpinner: React.FC = () => (
  <div className={styles.spinner}>
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
  </div>
);

export default wrapperHOC(SmartFilterSpinner, {
  componentName: "SmartFilterSpinner-SearchPage",
  showForChina: true,
});
